export const env: { [s: string]: (string | null); } = {
  'npm_package_version': '1.0.0',
  'IS_SERVER': 'true',
  'API_URL': 'https://api.consorzioitalia.eu'
};
